<template>
	<div class="sub_company_page">
		<div class="page_header">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>企业列表</el-breadcrumb-item>
				<el-breadcrumb-item>子公司列表</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="upload_btn">
				<el-upload
					class="certificate-uploader"
					:action="fileUpload"
					:show-file-list="false"
					:headers="Token"
					name="file"
					:on-success="handleFileUpload"
					accept=".xls,.xlsx">
					<el-button>批量导入</el-button>
				</el-upload>
			</div>
			<el-button @click="additionCompany">添加子公司</el-button>
		</div>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column
				prop="p_company_name"
				label="企业名称">
			</el-table-column>
			<el-table-column
				prop="company_name"
				label="子公司名称">
			</el-table-column>
			<el-table-column
				prop="position_num"
				label="岗位数量">
			</el-table-column>
			<el-table-column
				prop=""
				label="创建时间">
			</el-table-column>
			<el-table-column
				label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="handleEdit(scope.row.company_name, scope.row.p_company_name, scope.row.company_id)">编辑信息</el-button>
					<el-button type="text" size="mini" @click="handleOverFull(scope.row.company_id)">一键招满</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div v-if="tableData.length !== 0" class="page_container">
			<el-pagination
				background
				layout="prev, pager, next"
				@current-change="getPageList"
				:current-page.sync="page"
				:page-size="page_size"
				:total="total">
			</el-pagination>
		</div>
		<el-dialog title="添加企业" :visible.sync="dialogAdd" custom-class="self_dialog">
			<div class="dialog_inner">
				<el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="企业名称" prop="p_company_name">
						<el-input v-model="addForm.p_company_name"></el-input>
					</el-form-item>
					<el-form-item label="子公司名称" prop="company_name">
						<el-input v-model="addForm.company_name"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogAdd = false">取 消</el-button>
				<el-button type="primary" v-if="isAdd" @click="handleAddSubmit('addForm')">确认添加</el-button>
				<el-button type="primary" v-else @click="handleEditSubmit('addForm')">确认修改</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { host } from '../utils/host.js';
	import { getLocalStorage } from '../utils/localStorage.js';
	export default {
		data() {
			return {
				tableData: [],
				dialogAdd: false,
				addForm: {
					p_company_name: this.$route.query.name,
					company_name: '',
				},
				imageUrl: '',
				rules: {
					p_company_name: [
						{ required: true, message: '请输入企业名称', trigger: 'blur' }
					],
					company_name: [
						{ required: true, message: '请输入子公司名称', trigger: 'blur' }
					],
				},
				page: 1,
				page_size: 10,
				total: 0,
				companyid: 0,
				isAdd: true,
				actionUrl: host +'/picture', //图片上传接收地址
				Token: { Token: getLocalStorage()},
				fileUpload: host +'/hktopic/company/import',      //文件上传接收地址
			}
		},
		created() {
			this.getCompanyList()
		},
		methods: {
			getCompanyList() {
				this.$http.get('/hktopic/company', {
					params: {
						page: this.page,
						page_size: this.page_size,
						company_pid: this.$route.query.pid
					}
				}).then(res => {
					if (res.data.code == 0) {
						this.tableData = res.data.data.data;
						this.total = res.data.data.total;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			getPageList(page) {
				this.page = page;
				this.getCompanyList();
			},
			handleFileUpload(response) {
				if (response.code == 0) {
					this.$message.success('批量导入成功！');
					this.getCompanyList();
				}else {
					this.$message.error('上传失败' + response.message)
				}
			},
			additionCompany() {
				this.addForm.company_name = '';
				this.dialogAdd = true;
				this.isAdd = true;
			},
			handleEdit(name, pname, id) {
				this.isAdd = false;
				this.dialogAdd = true;
				this.addForm.company_name = name;
				this.addForm.p_company_name = pname;
				this.companyid = id;
			},
			handleAddSubmit(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						console.log(this.addForm)
						this.$http.post('/hktopic/son_company', { ...this.addForm }).then(res => {
							if (res.data.code == 0) {
								this.$message.success('子公司添加成功！');
								this.dialogAdd = false;
								this.getCompanyList();
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						return false;
					}
				});
				
			},
			handleEditSubmit(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						this.$http.put(`/hktopic/son_company/${this.companyid}`, { ...this.addForm }).then(res => {
							if (res.data.code == 0) {
								this.$message.success('信息修改成功！');
								this.dialogAdd = false;
								this.getCompanyList();
							}
						}).catch(err => {
							console.log(err)
						})
					}else {
						return false
					}
				})
			},
			handleOverFull(id) {
				this.$confirm('确认将该企业下的全部职位设为招满状态?', '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/hktopic/company/all_lower_shelf/${id}`).then(res => {
						if (res.data.code == 0) {
							this.$message.success('设置成功！');
							this.getCompanyList();
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {
				
				});
			},
		}
	}
</script>

<style lang="less">
	.sub_company_page{
		.upload_btn{
			display: inline-block;
			margin-right: 20px;
		}
	}
</style>
